import React from "react";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

//contexts
// import { UserProvider } from "./state/user/userContext";
import { GlobalProvider } from "./state/global/globalContext";
import { NotificationProvider } from "./state/notification/notificationContext";

//Router
import AppRoutes from "./router";

import "./theme/main.scss";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

function App() {
    return (
        <BrowserRouter>
            <GlobalProvider>
                {/* <UserProvider> */}
                    <NotificationProvider>
                        <QueryClientProvider client={queryClient}>
                            <AppRoutes />
                            <ReactQueryDevtools initialIsOpen={false} />
                        </QueryClientProvider>
                    </NotificationProvider>
                {/* </UserProvider> */}
            </GlobalProvider>
        </BrowserRouter>
    );
}

export default App;
